import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Proposal Personnel',
      type: 'table',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'save.proposal.personnel.row',
            },
          },
          {
            '{}': {
              alias: 'delete.proposal.personnel.row',
            },
          },
        ],
      },
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'rows',
                },
              },
              subqueries: {
                rows: {
                  filter: {
                    '=': [
                      {
                        '@': 'linkedProposalId',
                      },
                      {
                        '``': {
                          '@$': 'proposalId',
                        },
                      },
                    ],
                  },
                  target: 'ent:!proposal_personnel:!entry',
                  selection: {
                    '@.': '!id',
                  },
                  subqueries: {
                    linkedProposalId: {
                      ref: {
                        attr: 'attr:ent#!proposal_personnel#!entry:!proposal',
                      },
                      target: 'ent:!proposals:!proposal',
                      selection: {
                        '@.': '!id',
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                '=': [
                  {
                    '@': 'linkedProposalId',
                  },
                  {
                    '``': {
                      '@$': 'proposalId',
                    },
                  },
                ],
              },
              target: 'ent:!proposal_personnel:!entry',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      id: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      type: {
                        '{}': {
                          value: {
                            '@.': '!type',
                          },
                        },
                      },
                      personnelId: {
                        '{}': {
                          value: {
                            '@.': '!personnel',
                          },
                        },
                      },
                      personnelName: {
                        '{}': {
                          value: {
                            '@': 'personnelName',
                          },
                        },
                      },
                    },
                  },
                  onEdit: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              widget: {
                                '{}': {
                                  alias: 'edit.proposal.personnel.row.modal',
                                },
                              },
                              variables: {
                                '{}': {
                                  proposalId: {
                                    '@$': 'proposalId',
                                  },
                                  proposalPersonnelId: {
                                    '@.': '!id',
                                  },
                                },
                              },
                            },
                          },
                          operation: 'ui.modal',
                        },
                      },
                    },
                  },
                  onDelete: {
                    '{}': {
                      action: {
                        '{}': {
                          alias: 'delete.proposal.personnel.row',
                        },
                      },
                      confirm: {
                        '{}': {
                          title: 'Delete proposal personnel',
                          message: 'Are you sure?',
                        },
                      },
                      variables: {
                        '{}': {
                          proposalPersonnelId: {
                            '@.': '!id',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                personnelName: {
                  ref: {
                    attr: 'attr:ent#!proposal_personnel#!entry:!personnel',
                  },
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '@.': '!name',
                  },
                },
                linkedProposalId: {
                  ref: {
                    attr: 'attr:ent#!proposal_personnel#!entry:!proposal',
                  },
                  target: 'ent:!proposals:!proposal',
                  selection: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'personnelName',
                  direct: {
                    '{}': {
                      name: 'Person',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'type',
                  direct: {
                    '{}': {
                      name: 'Role Type',
                      type: 'TEXT',
                    },
                  },
                },
              },
            ],
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'edit.proposal.personnel.row',
                        },
                      },
                      variables: {
                        '{}': {
                          proposalId: {
                            '@$': 'proposalId',
                          },
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        },
      },
    },
  },
  variables: {
    proposalId: '?1',
  },
}
